import { HttpStatusCode } from 'data/protocols/http';
import {
  BadRequestError,
  ConflictError,
  InvalidCredentialsError,
  NotFoundError,
  UnexpectedError,
} from 'domain/errors';
import { ChangePersonCpfUseCaseInterface } from 'domain/usecases';

export class RemoteChangePersonCpf implements ChangePersonCpfUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ChangePersonCpfUseCaseInterface.Params,
  ): Promise<ChangePersonCpfUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.personHashId}/cpf`,
      method: 'patch',
      body: { cpf: params.cpf },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError(httpResponse.body?.message);
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFoundError(httpResponse.body?.message);
      case HttpStatusCode.conflict:
        throw new ConflictError(this.buildConflictMessage(httpResponse.body));
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }

  private buildConflictMessage(body): string {
    const conflictingPersonName = body?.conflictingPerson?.name;

    if (!conflictingPersonName) return body?.message;

    return `Este CPF já pertence a ${conflictingPersonName}.`;
  }
}
